<template>
  <div class="marker-symbol" :class="extraClass" :style="computedStyle">
    <!-- Використовуємо маску з кольором, якщо вказано -->
    <div v-if="src && maskStyle && Object.keys(maskStyle).length > 0"
         class="marker-image"
         :style="maskStyle" />
    <!-- Звичайний img, якщо немає маски -->
    <img v-else-if="src" :src="src" :alt="alt || 'marker'" class="marker-image" @error="onError" />
    <slot v-else />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  src?: string | null;
  alt?: string | null;
  styleObj?: Record<string, any>;
  extraClass?: string;
  maskStyle?: Record<string, any>;
  markerVerticalOffset?: number;
}>();

const computedStyle = computed(() => {
  const baseStyle = { ...(props.styleObj || {}) };
  if (props.markerVerticalOffset !== undefined && props.markerVerticalOffset !== 0) {
    baseStyle.transform = `translateY(${props.markerVerticalOffset}px)`;
  }
  return baseStyle;
});

function onError(e: Event) {
  const img = e.target as HTMLImageElement;
  img.src = '/markers/marker-1.svg';
  img.onerror = () => {
    img.style.display = 'none';
  };
}
</script>

<style scoped>
.marker-symbol {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.marker-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  user-select: none;
}
</style>


